import type { ListBuilderList } from '../../../types';
import { createVehicleColumns } from '../columns';

/**
 * "On a Trip" vehicles list configuration
 * Shows vehicles currently out on an active trip (in-progress or
 * pending-driver-confirm). Filters on the derived `vehicleTripStatus`.
 */
export const onRouteVehiclesList: ListBuilderList = {
	id: 'default-vehicles-on-route',
	name: 'On a Trip',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	filterRules: {
		vehicleTripStatus: {
			defaultValue: [{ id: 'on-trip', label: 'On a Trip' }],
		},
	},
	columns: createVehicleColumns(),
	defaultSortId: 'vehicle-name',
	sortOrder: 1,
};
